import { Trans, useTranslation } from 'react-i18next'

import { useRouting } from 'src/routes'
import { RelativeLink } from 'src/system/ui/link/RelativeLink'
import { DismissableWarning } from 'src/screens/matches/DismissableWarning'
import type { UserFieldsFragment as User } from 'src/graphql/types'

const dismissKey = 'valveAutoDownloadWarningDismissedAt'

// A steam-linked user whose automatch is inactive (no Steam game auth code) is
// not getting their Valve / CS2 official matches auto-downloaded — surface the
// warning. This is the same edge case the route gate lets through when the user
// is also FACEIT-linked.
export function shouldShowValveAutoDownloadWarning(
  user: User | null | undefined
): boolean {
  return Boolean(user?.isAccountLinked && !user.automatch.isActive)
}

export function ValveAutoDownloadWarning() {
  const { t } = useTranslation()
  const { routes } = useRouting()

  return (
    <DismissableWarning
      dismissKey={dismissKey}
      title={t('matches:valve_auto_download_warning:title')}
      dismissLabel={t('matches:valve_auto_download_warning:dismiss')}
    >
      <Trans i18nKey='matches:valve_auto_download_warning:body'>
        {' '}
        <RelativeLink to={routes.account}> </RelativeLink>
      </Trans>
    </DismissableWarning>
  )
}
